import styled, { useTheme } from 'styled-components';

import {
  Text,
  Flex,
  Box,
  Icon,
  Button,
  useScreenResolution,
  IconKeys,
} from 'dash-ui';

const Container = styled(Flex)`
  flex-direction: row;
  @media ${({ theme }) => theme.devices.mobile} {
    flex-direction: column;
  }
`;

const SubIconContainer = styled(Box)`
  position: absolute;
  background-color: ${({ theme }) => theme.colors.white};
  top: 0;
  right: 0;
  border-radius: 50%;
`;
const IconContainer = styled(Flex)`
  position: relative;
`;

function NoReactionsPlaceholder({
  message,
  subMessage,
  icon,
  subIcon,
  buttonProps,
}: {
  message: string;
  subMessage: string;
  icon: IconKeys;
  subIcon?: IconKeys;
  buttonProps: any;
}) {
  const theme = useTheme();
  const {
    devices: { isMobile },
  } = useScreenResolution();

  return (
    <Container
      p={[8, 0, 0, 0]}
      flex={1}
      w="100%"
      minHeight={586}
      alignItems="center"
    >
      <Flex
        w="100%"
        flex={1}
        alignItems="center"
        justifyContent={isMobile ? 'flex-start' : 'center'}
      >
        <IconContainer>
          <Icon
            name={icon}
            size={isMobile ? 50 : 126}
            color={theme.colors.b30}
          />
          {subIcon && (
            <SubIconContainer w={40} h={40}>
              <Icon name={subIcon} size={38} color={theme.colors.b30} />
            </SubIconContainer>
          )}
        </IconContainer>
      </Flex>
      <Flex flex={2} flexDirection="column" justifyContent="center">
        <Flex>
          <Text lg semibold>
            {message}
          </Text>
        </Flex>
        <Flex maxWidth={380} mt={0.5}>
          <Text color={theme.colors.n80}>{subMessage}</Text>
        </Flex>
        <Flex mt={2}>
          <Button px={8} variation="primary" {...buttonProps} />
        </Flex>
      </Flex>
    </Container>
  );
}

export default NoReactionsPlaceholder;
